export default {"src":"/org/_next/static/media/share.a16935a5.svg","height":17,"width":14,"blurWidth":0,"blurHeight":0};